import React from 'react';
import { ApolloError } from '@apollo/client';
import { LinearProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  IPaginationProps,
  LoadedContent,
} from '@occc-app/design-system';
import { ProductCategoryFragment } from '@occc/graphql';

import { ProductCategoriesTableRow } from './ProductCategoriesTableRow';

import { routeCreator } from '../utils';

type ProductCategoriesTableProps = {
  productCategories?: ProductCategoryFragment[] | null;
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  isUserPermittedToEditProductCategory: boolean;
};

export const ProductCategoriesTable: React.FC<ProductCategoriesTableProps> = ({
  productCategories,
  loading,
  error,
  paginationProps,
  isUserPermittedToEditProductCategory,
}) => {
  const navigate = useNavigate();

  const renderData = (items: ProductCategoryFragment[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Restriction</TableCell>
              <TableCell>Rank</TableCell>
              {isUserPermittedToEditProductCategory && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <ProductCategoriesTableRow
                key={item.id}
                productCategory={item}
                isActionColumnVisible={isUserPermittedToEditProductCategory}
                onRowClick={(productCategory) => navigate(routeCreator.details(productCategory.id))}
              />
            ))}
          </TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </>
    );
  };

  return (
    <LoadedContent<ProductCategoryFragment>
      error={error}
      loading={loading}
      items={productCategories}
      renderData={renderData}
    />
  );
};
